import { useQuery } from "react-query";
import { getBookingInvoice } from "services/booking.service";

export default function useInvoice(booking: string) {
  return useQuery(
    ["invoice", booking],
    async () => await getBookingInvoice(booking),
    {
      enabled: booking ? true : false,
    }
  );
}
